<template>
  <div>
    <div v-show="isLoadingAdPlayer" class="d-flex">
      <v-progress-circular
        v-show="isLoadingAdPlayer"
        :size="200"
        :width="8"
        indeterminate
        color="blue darken-2"
      ></v-progress-circular>
    </div>
    <div :id="`ad-player${adPlayerId}`" :data-adacado-dataset="adPlayerDatasetObj" class="adPlayer">
      <div v-pre></div>
    </div>
  </div>
</template>

<script>
import Parameter from 'parameter-mixin'
import FemsService from 'fems-service'

export default {
  mixins: [Parameter],
  name: 'storyboard-container',
  computed: {
    adPlayerDatasetObj() {
      return this.$constructAdacadoDataset({
        storyboard: this.storyboardToRender,
        isStoryboardPreview: true,
        INVENTORIES: this.inventories,
        isQuickStart: true,
        adPlayerId: this.adPlayerId,
        shouldDisplayWatermark: this.shouldDisplayWatermark,
      })
    },
  },
  props: {
    index: Number,
    template: Object,
    updatedStoryboardIdx: Number,
    inventories: Array,
    shouldDisplayWatermark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      adPlayerId: undefined,

      // For template viewer: it only used to display 3rd party templates (those not created in Ace/template editor and have no blueprint)
      // Create an ephemoral storyboard object (not related to existing current storyboard) of one tamplate
      // only used to feed Ad-Player FEMS in order to display a 3rd party template
      storyboardToRender: {
        properties: {
          storyboardJson: {
            height: this.template.properties.templateJson.height,
            width: this.template.properties.templateJson.width,
            initialBlankDelay: 0,
            isSingleRotation: true,
            templates: [
              {
                templateID: this.template.templateId,
                required: true,
                transitionIn: undefined,
                transitionOut: undefined,
                transitionInDuration: 0,
                transitionOutDuration: 0,
                delay: 0,
              },
            ],
          },
        },
        // Not part of normal storyboard object
        templates: [
          {
            ...this.template.properties,
            templateId: this.template.templateId,
          },
        ],
      },
      isLoadingAdPlayer: true,
    }
  },
  mounted() {
    this.adPlayerId = `${this.template.templateId}-${Date.now()}-${this.index}`
    this.guibus_subscribe(`mounted:ad-player-${this.adPlayerId}`, this.handleMounted)
    // render storyboard
    this.$nextTick(() => {
      FemsService.renderChildFems('ad-player', 'v2', `ad-player${this.adPlayerId}`)
    })
  },
  methods: {
    handleMounted() {
      this.isLoadingAdPlayer = false
    },
  },
  watch: {
    updatedStoryboardIdx(newVal) {
      if (newVal === this.index) {
        // teardown ad-player
        FemsService.teardownChildFems('ad-player', 'v2', `ad-player${this.adPlayerId}`)
        this.$nextTick(() => {
          // render storyboard
          FemsService.renderChildFems('ad-player', 'v2', `ad-player${this.adPlayerId}`)
          this.$emit('storyboardUpdated')
        })
      }
    },
  },
  destroyed() {
    // teardown ad-player
    FemsService.teardownChildFems('ad-player', 'v2', `ad-player${this.adPlayerId}`)
    this.guibus_unsubscribe(`mounted:ad-player-${this.adPlayerId}`, this.handleMounted)
  },
}
</script>

<style lang="scss" scoped>
.adPlayer {
  pointer-events: none;
}
</style>
